import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect, useState } from "react";
import useAuthUser from "./authUser";

const useDefaultPage = () => {
    const isAuthenticated = useIsAuthenticated();
    const { isRegistered, isAdmin, isUser, isDataLoading, isAuthUserNotRegistered } = useAuthUser();

    const [defaultPage, setDefaultPage] = useState<string | undefined>();

    useEffect(() => {
        if (!isDataLoading && isRegistered) {
            setDefaultPage('/dashboard');
        }
    }, [isAuthenticated, isRegistered, isAuthUserNotRegistered, isAdmin, isUser]);

    return { defaultPage };
};

export default useDefaultPage;
